import { gql } from '@apollo/client';

export default gql`
  mutation GeneratePromoCodes($input: GeneratePromoCodesInput!) {
    generatePromoCodes(input: $input) {
      status
    }
  }
`;
